export default __webpack_public_path__ + "static/media/calxyl-kanuele.9b4c71e0.png";